import http from "../assets/extra/_httpServices";
import { urls } from "../components/common/constants";
import actionTypes from "./ActionTypes";

export const updateLoadingScreen = (data) => {
    return {
        type: actionTypes.UPDATE_LOADING_SCREEN,
        payload: data,
    }
}
export const updateCityList = (data) => {
    return {
        type: actionTypes.CITY_List,
        payload: data,
    }
}
export const updateGuestTypeList = (data) => {
    return {
        type: actionTypes.GUEST_TYPE_LIST,
        payload: data,
    }
}

export const updateAgentList = (data) => {
    return {
        type: actionTypes.AGENT_LIST,
        payload: data,
    }
}

export const updateBranchList = (data) => {
    return {
        type: actionTypes.BRANCH_LIST,
        payload: data,
    }
}
export const updatePickupLocation = (data) => {
    return {
        type: actionTypes.PICKUP_LOCATION_LIST,
        payload: data,
    }
}
export const updateDropoffLocation = (data) => {
    return {
        type: actionTypes.DROPOFF_LOCATION_LIST,
        payload: data,
    }
}

export const updateBranchUserList = (data) => {
    return {
        type: actionTypes.BRANCH_USER_LIST,
        payload: data,
    }
}

export const updateShowAlert = (data) => {
    return {
        type: actionTypes.SHOW_ALERT,
        payload: data,
    }
}

export const updateBkgColor = (data) => {
    return {
        type: actionTypes.BKG_COLOR,
        payload: data,
    }
}
export const updateSubRoutesCity = (data) => {
    return {
        type: actionTypes.SUB_ROUTES_CITY,
        payload: data,
    }
}

export const updateBusesListAll = (data) => {
    return {
        type: actionTypes.BUSES_LIST_ALL,
        payload: data,
    }
}


export const updateDriverListAll = (data) => {
    return {
        type: actionTypes.DRIVER_LIST_ALL,
        payload: data,
    }
}

export const updateConductorListAll = (data) => {
    return {
        type: actionTypes.CONDUCTOR_LIST_ALL,
        payload: data,
    }
}
export const updatePickupManListAll = (data) => {
    return {
        type: actionTypes.PICKUP_MAN_LIST_ALL,
        payload: data,
    }
}
export const updateUserDetails = (data,roleData) => {
    return {
        type: actionTypes.USER_DETAILS,
        payload: data,
        roleData:roleData
    }

}
export const updateTripList = (data) => {
    return {
        type: actionTypes.TRIP_LIST,
        payload: data,
    }
}

export const updatePaymentMode = (data) => {
    return {
        type: actionTypes.PAYMENT_MODE,
        payload: data,
    }
}

export const updateAmenities = (data) => {
    return {
        type: actionTypes.AMENITIES_LIST,
        payload: data,
    }
}
export const updateUserRole = (data, roleRight) => {
    return {
        type: actionTypes.USER_ROLE,
        payload: data,
        roleRight: roleRight
    }
}
// export const LoginCall = (url, body) => (dispatch) => {
//     return new Promise((resolve, reject) => {
//         dispatch(updateLoadingScreen(true))
//         http.HttpCall(url, "post", {}, body)
//             .then((res) => {
//                 dispatch(updateLoadingScreen(false))
//                 return resolve(res)
//             })
//             .catch((error) => {
//                 dispatch(updateLoadingScreen(false))
//                 reject(error)
//             })
//     })
// }
export const LoginCall = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.LoginCall, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTodayTomorrowScheduleDataList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getTodayTomorrowScheduleDataList, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getCityList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls?.getCityList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response.status === 200 && response.data.APIGetCompanyCityPairsResult.Status) {
                    dispatch(updateCityList(response.data.APIGetCompanyCityPairsResult.CityPairs));
                } else {
                    dispatch(updateCityList([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                console.log("Error: ", error);
                dispatch(updateCityList([]));
            });
    };
};
export const getGuestTypeList = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getGuestTypeList, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIGuestTypeListAllResult);
                    dispatch(updateGuestTypeList(parsedData.Table));
                } else {
                    dispatch(updateGuestTypeList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateGuestTypeList([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};
export const getAgentList = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getAgentList, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIGetAllAgentsListResult);
                    dispatch(updateAgentList(parsedData.Table));
                } else {
                    dispatch(updateAgentList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateAgentList([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};
export const getBranchList = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getBranchList, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIGetBranchListAllResult);
                    dispatch(updateBranchList(parsedData.Table));
                } else {
                    dispatch(updateBranchList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateBranchList([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};
export const getBranchUserList = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getBranchUserList, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIGetUserListAllResult);
                    dispatch(updateBranchUserList(parsedData.Table));
                } else {
                    dispatch(updateBranchUserList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateBranchUserList([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};
export const getSearchedTripList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getSearchedTripList, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getSeatChart = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getSeatChart, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getPickupLocation = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getPickupLocation, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIGetTripPickupsV2Result);
                    dispatch(updatePickupLocation(parsedData.Table));
                } else {
                    dispatch(updatePickupLocation([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updatePickupLocation([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};
export const getDropoffLocation = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getDropoffLocation, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIGetTripDropoffsV2Result);
                    dispatch(updateDropoffLocation(parsedData.Table));
                } else {
                    dispatch(updateDropoffLocation([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateDropoffLocation([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};
export const cashBasedBooking = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.cashBasedBooking, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBookingTypesColors = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getBookingTypesColors, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updateBkgColor(JSON.parse(response.data.APIGetCompanyBookingTypesColorsResult)?.Table));
                } else {
                    dispatch(updateBkgColor([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateBkgColor([]));
            });
    };
};



export const getSubRoutesCity = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getSubRoutesCity, data)
            .then((response) => {
                if (response.status === 200) {
                    let resData = JSON.parse(response?.data.APIMavenTripSubRoutesFaresLuggageFareResult.Data)?.Table
                    dispatch(updateSubRoutesCity(resData));
                    return resolve(response)
                } else {
                    dispatch(updateSubRoutesCity([]));
                    return resolve(response)
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateSubRoutesCity([]));
                dispatch(updateLoadingScreen(false))
                reject(error)
            });
    })
}



export const getBusesListAll = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getBusesListAll, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updateBusesListAll(JSON.parse(response?.data.APIBusesListAllResult)?.Table));
                } else {
                    dispatch(updateBusesListAll([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateBusesListAll([]));
            });
    };
};


export const getDriverListAll = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getDriverListAll, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updateDriverListAll(JSON.parse(response?.data.APIDriverConductorListAllResult)?.Table));
                } else {
                    dispatch(updateDriverListAll([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateDriverListAll([]));
            });
    };
};

export const getConductorListAll = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getConductorListAll, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updateConductorListAll(JSON.parse(response?.data.APIDriverConductorListAllResult)?.Table));
                } else {
                    dispatch(updateConductorListAll([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateConductorListAll([]));
            });
    };
};

export const getPickupManListAll = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getPickupManListAll, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updatePickupManListAll(JSON.parse(response?.data.APIPickupManListAllResult)?.Table));
                } else {
                    dispatch(updatePickupManListAll([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updatePickupManListAll([]));
            });
    };
};


export const busScheduleInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.busScheduleInsertUpdate, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}




export const mavenDevices = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.mavenDevices, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getHasServiceTax = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpGet(urls.getHasServiceTax, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const getCompanyServicetax = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpGet(urls.getCompanyServicetax, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getConcessionTypes = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpGet(urls.getConcessionTypes, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getCouponCardList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpGet(urls.getCouponCardList, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const updateCoupon = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpGet(urls.updateCoupon, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const validateCouponOTP = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpGet(urls.validateCouponOTP, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const updateSpecialQuota = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.updateSpecialQuota, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const updateBookingsModifyWithNameChange = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.updateBookingsModifyWithNameChange, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBookingsCancelV2 = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBookingsCancelV2, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}



export const updateBookingsModify = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.updateBookingsModify, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const sendEmail = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.sendEmail, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const reSendSMS = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.reSendSMS, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBookingInquiryRptData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getBookingInquiryRptData, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const sendGPSSMS = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.sendGPSSMS, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const updateSeatwiseFare = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.APIMavenCutRootFareSchedule, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const phoneConfirm = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.phoneCnfrm, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getGenerateOTPForCancelChart = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGenerateOTPForCancelChart, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getValidateOTP = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getValidateOTP, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const updateCancelTicketForChartCancel = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.updateCancelTicketForChartCancel, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTripList = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getTripList, params)
            .then((response) => {
                if (response.status === 200) {
                    const parsedData = JSON.parse(response.data.APIMavenTripsListAllResult.Data);
                    dispatch(updateTripList(parsedData.Table));
                } else {
                    dispatch(updateTripList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateTripList([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};


export const getPaymentMode = (params) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getPaymentMode, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updatePaymentMode(response.data.APIRechargePaymentModesListAllResult));
                } else {
                    dispatch(updatePaymentMode([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updatePaymentMode([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};

export const updateAgentRecharges = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.updateAgentRecharges, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const sendSMSForChartTransfer = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.sendSMSForChartTransfer, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getChartLayout = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getChartLayout, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const updateArrgTransferNew = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.updateArrgTransferNew, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const sendSMSForArrangementTransfer = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.sendSMSForArrangementTransfer, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getGroupBoardingFilter = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGroupBoardingFilter, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}




export const updatePNRBoardedSeatWise = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.updatePNRBoardedSeatWise, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}



export const getCompanyAmenitiesAll = (params = {}) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getCompanyAmenitiesAll, params)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(updateAmenities(JSON.parse(response.data.APIGetCompanyAmenitiesAllResult).Table));
                } else {
                    dispatch(updateAmenities([]));
                }
                dispatch(updateLoadingScreen(false))
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateAmenities([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};



export const getTripsConfiguredDetailsList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTripsConfiguredDetailsList, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const updateTripSchedule = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.updateTripSchedule, "POST", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getPkpInquiryPDF = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPkpInquiryPDF, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTridDetailsByTripId = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getTridDetailsByTripId, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const SendPickupSMS = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.SendPickupSMS, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getRoleRightsConfig = (params = {}) => {
    return (dispatch) => {
        http
            .HttpGet(urls?.getRoleRightsConfig, params)
            .then((response) => {
                if (response?.status === 200) {
                    const parsedData = JSON.parse(response.data.APIRoleRightsConfigListAllResult);
                    dispatch(updateUserRole(parsedData.Table || [], parsedData.Table1?.[0] || {}))
                    //sessionStorage.setItem("userRole", JSON.stringify(parsedData?.Table || []));
                } else {
                    dispatch(updateUserRole([], {}))
                    // sessionStorage.setItem("userRole", JSON.stringify([]));
                }
                dispatch(updateLoadingScreen(false))
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateUserRole([], {}))
                //sessionStorage.setItem("userRole", JSON.stringify([]));
                dispatch(updateLoadingScreen(false))
            });
    };
};